module.exports = __webpack_public_path__ + "media/images/Guide-voyage-hortense-ee77abaa81bbc18233b90cd2ab2412a1.webp";